module.exports = __webpack_public_path__ + "img/logo.91e1f128.png";